export const SET_OPENKEYS = 'menu/setOpenKeys';

export function setOpenKeys(keys) {
  return {
    type: SET_OPENKEYS,
    payload: keys,
  };
}
